import { BsPatchCheckFill } from 'react-icons/bs'
export const frontendSkills = [
    {
        id: 1,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Node.js',
        experience: 'Experienced',
    },
    {
        id: 2,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'JavaScript',
        experience: 'Experienced',
    },
    {
        id: 3,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Express.js',
        experience: 'Experienced',
    },
    {
        id: 4,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'MySQL',
        experience: 'Experienced',
    },
    {
        id: 5,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'MongoDB',
        experience: 'Intermediate',
    },
    {
        id: 6,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'SQL',
        experience: 'Experienced',
    },
    {
        id: 7,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'React JS',
        experience: 'Beginner',
    },
    {
        id: 8,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'HTML / CSS',
        experience: 'Intermediate',
    },
    {
        id: 9,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'GitHub',
        experience: 'Intermediate',
    },
]

export const familiarSkills = [
    {
        id: 1,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Docker',
        experience: 'Intermediate',
    },
    {
        id: 2,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Redis',
        experience: 'Intermediate',
    },
    {
        id: 3,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Elasticsearch',
        experience: 'Intermediate',
    },
    {
        id: 4,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Socket.io',
        experience: 'Intermediate',
    },
    {
        id: 5,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'AWS (S3, SES)',
        experience: 'Intermediate',
    },
    {
        id: 6,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Linux',
        experience: 'Intermediate',
    },
    {
        id: 7,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'JWT Auth',
        experience: 'Experienced',
    },
    {
        id: 8,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Firebase',
        experience: 'Intermediate',
    },
]
export const industryKnowledge = [
    {
        id: 1,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Microservices',
        experience: 'Experienced',
    },
    {
        id: 2,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'REST APIs',
        experience: 'Experienced',
    },
    {
        id: 3,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Event-driven Systems',
        experience: 'Intermediate',
    },
    {
        id: 4,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Payment Integrations',
        experience: 'Experienced',
    },
    {
        id: 5,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Scalable Systems',
        experience: 'Intermediate',
    },
    {
        id: 6,
        icon : <BsPatchCheckFill className='experience__details-icon' />,
        name : 'Web Security',
        experience: 'Intermediate',
    },
]
